module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "tableSize flipTable"
  }, [_c('tr', _vm._l((_vm.header), function(head, n) {
    return _c('th', {
      key: n,
      staticClass: "tableHeader"
    }, [_vm._v("\n      " + _vm._s(head) + "\n    ")])
  }), 0), _vm._v(" "), _c('tbody', [_vm._l((_vm.viewData), function(data, index) {
    return (_vm.showData(data.ad_knd_nm)) ? _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "sortCenter"
    }, [_vm._v("\n        " + _vm._s(data.ad_knd_nm) + "\n      ")]), _vm._v(" "), _c('td', {
      staticClass: "sortCenter"
    }, [_vm._v("\n        " + _vm._s(data.geo_nm) + "\n      ")]), _vm._v(" "), _c('td', {
      staticClass: "sortRight"
    }, [_c('div', {
      staticClass: "data_wrap"
    }, [_vm._v("\n          " + _vm._s(_vm.parseDataType(data.imp_cnt)) + "\n        ")])]), _vm._v(" "), _c('td', {
      staticClass: "sortRight"
    }, [_c('div', {
      staticClass: "data_wrap"
    }, [_vm._v("\n          " + _vm._s(_vm.parseDataType(data.click_cnt)) + "\n        ")])]), _vm._v(" "), _c('td', {
      staticClass: "sortRight"
    }, [_c('div', {
      staticClass: "data_wrap"
    }, [_vm._v("\n          " + _vm._s(data.ctr.toFixed(2)) + "\n        ")])])]) : _vm._e()
  }), _vm._v(" "), _c('tr', [_vm._m(0), _vm._v(" "), _c('td'), _vm._v(" "), _vm._l((_vm.totalKey), function(data, key) {
    return _c('th', {
      key: key,
      staticClass: "sortCenter"
    }, [_c('div', {
      staticClass: "data_wrap"
    }, [_vm._v("\n          " + _vm._s(_vm.parseData(_vm.totalData[data], data)) + "\n        ")])])
  })], 2)], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "sortCenter total"
  }, [_c('b', [_vm._v("합계")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7659bd22","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaign/geo/GeoTable.vue
// module id = 863
// module chunks = 1